import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const ProceduresChartsDataContext = createContext();

const ProceduresChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const top = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PROCEDURES_TOP,
            url: 'governanceroom/cihadashboard/proceduresTop'
        },
        filterParams
    );

    const byModality = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PROCEDURES_BY_MODALITY,
            url: 'governanceroom/cihadashboard/proceduresByModality'
        },
        filterParams
    );

    const modalityByYear = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PROCEDURES_MODALITY_BY_YEAR,
            url: 'governanceroom/cihadashboard/proceduresModalityByYear'
        },
        filterParams,
        true
    );

    const utiDistribution = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PROCEDURES_UTI_DISTRIBUTION,
            url: 'governanceroom/cihadashboard/proceduresUtiDistribution'
        },
        filterParams
    );

    const queries = [top, byModality, modalityByYear, utiDistribution];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);

    const chartData = {
        top: top.data?.top_procedimentos || [],
        byModality: byModality.data?.modalidade || [],
        modalityByYear: modalityByYear.data?.modalidade_por_ano || {},
        utiDistribution: utiDistribution.data?.dist_uti || {}
    };

    return (
        <ProceduresChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </ProceduresChartsDataContext.Provider>
    );
};

export default ProceduresChartsDataProvider;
